import { Typography } from '@material-ui/core';
import { FC } from 'react';
import { AgentNetConfirmationDialog } from 'ui-kit/components/modal/ConfirmationDialog';
import { UNDERWRITER_PRODUCT_TEST_IDS } from '../feature-details-tabs';
import { getFraudPreventionServiceDisplayName } from './fraudPreventionServices';

export interface OtherUnderwritersDisableDialogProps {
  open: boolean;
  productName: string;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

export const OtherUnderwritersDisableDialog: FC<OtherUnderwritersDisableDialogProps> = ({
  open,
  productName,
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  const displayName = getFraudPreventionServiceDisplayName(productName);
  const dialogTextHTML = (
    <Typography id="alert-dialog-description" component="div" variant="body1" color="textPrimary">
      <Typography component="p" variant="body1" paragraph>
        <strong>{displayName}</strong> will no longer be available for non–First American transactions. Previously
        verified results will also be unavailable.
      </Typography>
      <Typography component="p" variant="body1">
        You can continue using this add-on for First American transactions at no additional cost.
      </Typography>
    </Typography>
  );

  return (
    <AgentNetConfirmationDialog
      showDialogActions
      disabled={isSubmitting}
      disablePrimaryBtn={isSubmitting}
      disableCrossIconClick={isSubmitting}
      disableBackDropClick={isSubmitting}
      updatedQAPrefix={{
        close: UNDERWRITER_PRODUCT_TEST_IDS.disableDialog.close,
        cancel: UNDERWRITER_PRODUCT_TEST_IDS.disableDialog.cancel,
        submit: UNDERWRITER_PRODUCT_TEST_IDS.disableDialog.disableAddOn,
      }}
      onConfirm={onConfirm}
      open={open}
      onDismissAction={onClose}
      dialogTitle="Disable Add-On?"
      dialogTitleColor="textPrimary"
      dialogBtnContent="Disable Add-On"
      dialogCancelBtnContent="Cancel"
      dialogTextHTML={dialogTextHTML}
    />
  );
};
